var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-info"},[_c('div',{staticClass:"text-info__wrap"},[(_vm.payload.title)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.payload.title)}}):_vm._e(),_c('div',{class:{ emptyTitle: !_vm.payload.title },domProps:{"innerHTML":_vm._s(_vm.payload.detail)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }